import pt from 'prop-types';
import React from 'react';

const TaipeiCycleAward = ({ year, className, trackingId }) => {
  if (!year) {
    return null;
  }

  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 261.62 133.49"
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <defs>
          <style>.cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#d32c25;}.cls-4{clip-path:url(#clip-path);}.cls-5{font-size:15.56px;font-family:SuisseIntl-Medium,SuisseIntl;font-weight:500;}.cls-5,.cls-6{fill:#211815;}.cls-6{font-size:17.73px;font-family:SuisseIntl-Bold,Suisse Intl;font-weight:700;}.cls-7{fill:#2b97d4;}.cls-8{fill:#b1cb41;}</style>
          <clipPath id="clip-path">
            <rect class="cls-1" x="197.73" y="54.07" width="44.55" height="22.82" />
          </clipPath>
        </defs>
        <title>TPCdiA2024_logo</title>
        <rect x="0" y="0" width="261.62" height="133.49" fill="white"/>
        <rect class="cls-2" x="197.73" y="54.07" width="44.55" height="22.82" />
        <rect class="cls-3" x="220.55" y="55.16" width="20.64" height="20.64" />
        <g class="cls-4">
          <path class="cls-2"
            d="M224.91,71.45h3.26v-7.6h-3.26Zm1.62-12.17a1.85,1.85,0,1,0,1.85,1.85,1.85,1.85,0,0,0-1.85-1.85m7.06,3.48h3.26V59.5h-3.26Zm-4.34,8.69h3.26v-12h-3.26Zm4.34-4.34h3.26V63.85h-3.26Z" />
          <path class="cls-3"
            d="M203.53,70.14c0,.48,0,1-.06,1.32H202.2c.06-.65.08-1.5.08-2.31V59.5h1.39v3.57c0,.75,0,1.5,0,2h0a3,3,0,0,1,2.61-1.41c2,0,3.27,1.69,3.27,3.92s-1.31,4.08-3.39,4.08a2.92,2.92,0,0,1-2.58-1.5Zm.15-2.47a2.52,2.52,0,0,0,2.22,2.78c1.3,0,2.14-1.22,2.14-2.8s-.78-2.83-2.12-2.83-2.24,1.26-2.24,2.85" />
          <path class="cls-3"
            d="M213.14,68.45c.17.48.42,1.33.56,1.85h0c.15-.52.42-1.4.57-1.85l1.56-4.63h1.43l-2.72,7.56c-.95,2.59-1.62,3.4-3.18,3.4a3.18,3.18,0,0,1-.87-.12l.09-1.12a2.48,2.48,0,0,0,.68.11c.82,0,1.17-.44,1.66-1.86l-2.89-8h1.54Z" />
        </g>
        <text class="cls-5" transform="translate(121.1 49.77) scale(1 1.06)">d&amp;i a</text>
        <text class="cls-5" transform="translate(157.8 49.77) scale(1 1.06)">w</text>
        <text class="cls-5" transform="translate(169.01 49.77) scale(1 1.06)">a</text>
        <text class="cls-5" transform="translate(177.86 49.77) scale(1 1.06)">r</text>
        <text class="cls-5" transform="translate(183.43 49.77) scale(1 1.06)">ds ${year}</text>
        <text class="cls-6" transform="translate(121.18 32.69) scale(1 1.06)">T</text>
        <text class="cls-6" transform="translate(131.34 32.69) scale(1 1.06)">AIPEI </text>
        <text class="cls-6" transform="translate(182.48 32.69) scale(1 1.06)">C</text>
        <text class="cls-6" transform="translate(195.21 32.69) scale(1 1.06)">Y</text>
        <text class="cls-6" transform="translate(206.61 32.69) scale(1 1.06)">CLE</text>
        <path class="cls-7"
          d="M40.32,72.38a17.52,17.52,0,0,0-3.22,1.19l-.07,0a17,17,0,0,0,7.61,32.27,17.16,17.16,0,0,0,7.53-1.75l.37-.18a17.87,17.87,0,0,0,2-1.24,18.44,18.44,0,0,0,1.83-1.57L53.21,98a12.55,12.55,0,1,1-4.15-20.93,26.21,26.21,0,0,1-1.28-5,16.68,16.68,0,0,0-3.16-.31,17,17,0,0,0-4.3.56" />
        <path class="cls-7"
          d="M55.48,106.62c-.57.34-1.13.67-1.74,1a20.83,20.83,0,0,1-23.82-4,20.87,20.87,0,0,1,6.13-33.72l.15-.06a20.27,20.27,0,0,1,4.34-1.36l.31-.06.8-.13.47-.07.85-.08c.54,0,1.09-.07,1.64-.07a20.78,20.78,0,0,1,2.85.2c0-.08,0-.15,0-.23V63.71a23.94,23.94,0,0,0-2.81-.16A25.3,25.3,0,1,0,62.23,107L59,103.82a20.91,20.91,0,0,1-2.26,1.93c-.41.31-.83.6-1.27.87" />
        <path class="cls-8"
          d="M64.68,90.24A24.17,24.17,0,0,1,49.9,68V32.1H32.59V19.35H79.92V32.1H62.65V68a11.32,11.32,0,0,0,2,6.47Z" />
        <path class="cls-8"
          d="M67.13,108.52V68.05A24.15,24.15,0,0,1,114.64,62a27.59,27.59,0,0,0-12,6.63c0-.19,0-.38,0-.57a11.39,11.39,0,0,0-22.78-.46v40.93Z" />
        <path class="cls-8"
          d="M82.32,92.17V79.41l9.39.08v-.06a11.33,11.33,0,0,0,4.21-1,27.66,27.66,0,0,0-2,10.4A26.37,26.37,0,0,0,94.1,92c-.78.09-1.55.15-2.28.17h-.44v0Z" />
        <path class="cls-7"
          d="M130.65,107.64a20.91,20.91,0,0,1-9,2,20.83,20.83,0,1,1,0-41.65,21,21,0,0,1,6.68,1.09c.4.14.8.27,1.19.43a20.51,20.51,0,0,1,2.22,1.06,10.42,10.42,0,0,1,1.16.69l.14.09a20.91,20.91,0,0,1,3,2.41l3.16-3.16a25.31,25.31,0,1,0,0,36.41l-3.2-3.19a20.6,20.6,0,0,1-1.55,1.4c-.25.21-.55.38-.81.58-.43.31-.81.58-1.26.86s-1.6.86-1.78,1" />
        <path class="cls-7"
          d="M129.54,73.73l-.28-.14-.08,0a17.24,17.24,0,0,0-7.51-1.74,17,17,0,0,0,0,34.06,17.15,17.15,0,0,0,7.52-1.75l.54-.27.16-.11a14.27,14.27,0,0,0,1.57-1,17.2,17.2,0,0,0,1.9-1.59L130.23,98a12.55,12.55,0,1,1,0-18.37l3.17-3.18a16.8,16.8,0,0,0-3.12-2.33l-.74-.41" />
        `,
      }}
    />
  );
};

TaipeiCycleAward.propTypes = {
  year: pt.number.isRequired,
  className: pt.string,
  trackingId: pt.bool,
};

TaipeiCycleAward.defaultProps = {
  className: '',
};

export default TaipeiCycleAward;
